import React from "react";
import { useAppSelector } from "../../../store/storeHooks";
import { useLocation, useNavigate } from "react-router-dom";

export const PrivacyPolicySmartvu = () => {
    return (
         <>
        <div className="contentBox">
            <h2>Terms of Use for FineVu Wi-Fi Service</h2>
            <ol>
                <li>
                    <div className="titleBox">
                        <p><span>Article 1</span></p> <p>Purpose</p>
                    </div>
                    <div className="txtWrap">
                        <p>These Terms of Use define the rights, obligations, and responsibilities between Finedigital Inc. (hereinafter referred to as the “Company”) and the Member, as well as other necessary matters in relation to the use of the FineVu Wi-Fi service provided by the Company.</p>
                    </div>
                </li>

                <li>
                    <div className="titleBox">
                        <p><span>Article 2</span></p><p>Definitions</p>
                    </div>
                    <div className="txtWrap">
                        <ol>
                            <li>“Member” refers to a person who has downloaded the App on their smartphone, agreed to these Terms, and has been granted the right to use the service.</li>
                            <li>“App” refers to the application provided by the Company.</li>
                            <li>“Device” refers to the in-vehicle dashcam handled by the Company.</li>
                            <li>“Service” refers to all services provided by the Company through the App, including event detection, uploads, GPS tracking, FOTA updates, two-way communication, geo-fencing, and fleet management.</li>
                            <li>“Post” refers to all information and links posted by the Member while using the mobile service, including text, documents, images, audio, videos, or a combination thereof.</li>
                        </ol>
                        <p>Unless otherwise defined in this Article, the definitions of terms shall be governed by applicable laws and general commercial practices.</p>
                    </div>
                </li>

                <li>
                    <div className="titleBox">
                        <p><span>Article 3</span></p><p>Posting of Terms</p>
                    </div>
                    <div className="txtWrap">
                        <p>The Company shall post these Terms in a manner easily accessible to Members on the initial screen of the App.</p>
                    </div>
                </li>

                <li>
                    <div className="titleBox">
                        <p><span>Article 4</span></p><p>Amendment of Terms</p>
                    </div>
                    <div className="txtWrap">
                        <p>1. The Company may amend these Terms within the scope permitted by applicable laws. In such cases, the Company shall provide prior notice through the App, specifying the effective date and reason for the amendment, at least 15 days in advance. However, changes related to new functions or legal compliance may become effective immediately without prior notice.</p>
                        <p>2. Amended Terms apply only to contracts concluded after the effective date. Contracts signed before that date shall be governed by the previous Terms.</p>
                    </div>
                </li>

                <li>
                    <div className="titleBox">
                        <p><span>Article 5</span></p><p>Provision of Services</p>
                    </div>
                    <div className="txtWrap">
                        <p>By agreeing to these Terms, Members may use the services defined in Article 2. The Company provides the services free of charge, but communication fees incurred during service use shall follow the Member’s mobile carrier’s policies.</p>
                    </div>
                </li>

                <li>
                    <div className="titleBox">
                        <p><span>Article 6</span></p><p>Use of Services</p>
                    </div>
                    <div className="txtWrap">
                        <p>Members may use the services 24 hours a day, 365 days a year. However, the Company may suspend or discontinue services for reasons outlined in Articles 8 and 11.</p>
                    </div>
                </li>

                <li>
                    <div className="titleBox">
                        <p><span>Article 7</span></p><p>Changes to Services</p>
                    </div>
                    <div className="txtWrap">
                        <p>The Company may change the content, delivery method, or other aspects of the service as necessary, in accordance with Article 4. Notice of such changes shall be provided via the App at least 15 days prior to the effective date.</p>
                    </div>
                </li>

                <li>
                    <div className="titleBox">
                        <p><span>Article 8</span></p><p>Suspension or Discontinuation of Service</p>
                    </div>
                     <div className="txtWrap">
                        <p>The Company may suspend or discontinue services in the following cases. In such instances, the Company shall notify Members via the App at least 15 days in advance, except in unavoidable circumstances:</p>
                        <ol>
                            <li>- When discontinuing or terminating the service</li>
                            <li>- When changes to the service content are required</li>
                            <li>- When a Member intentionally or through gross negligence disrupts service operations</li>
                            <li>- When a Member violates these Terms, public order, or good morals</li>
                        </ol>
                    </div>
                </li>

                <li>
                    <div className="titleBox">
                        <p><span>Article 9</span></p><p>Company Responsibilities</p>
                    </div>
                    <div className="txtWrap">
                        <p>The Company is responsible for the following:</p>
                        <ul>
                            <li>- Complying with these Terms and applicable laws, including publishing and adhering to a privacy policy to protect personal data</li>
                            <li>- Ensuring Members can use the service smoothly through appropriate measures</li>
                            <li>- Fulfilling notice obligations when changing or discontinuing services under Article 7 or 8</li>
                        </ul>
                    </div>
                </li>

                <li>
                    <div className="titleBox">
                        <p><span>Article 10</span></p><p>Member Responsibilities</p>
                    </div>
                    <div className="txtWrap">
                        <p>Members shall:</p>
                        <ul>
                            <li>- Comply with these Terms and the Company’s privacy policy</li>
                            <li>- Not use the service content for profit (e.g., modifying, selling, or sharing with third parties)</li>
                            <li>- Safeguard their login credentials (ID and password) against unauthorized use</li>
                            <li>- Comply with the Act on Promotion of Information and Communications Network Utilization and Information Protection, etc., and refrain from prohibited or indecent behavior</li>
                        </ul>
                    </div>
                </li>

                <li>
                    <div className="titleBox">
                        <p><span>Article 11</span></p><p>Prohibited Acts</p>
                    </div>
                     <div className="txtWrap">
                        <p>Members shall not engage in the following:</p>
                        <ul>
                            <li> Defaming or harming others</li>
                            <li> Infringing intellectual property, portrait rights, or other rights of the Company or third parties</li>
                            <li> Collecting or sharing personal data of other members without consent</li>
                            <li> Exploiting bugs or distributing malicious code</li>
                            <li> Intentionally disrupting the Company’s services or sending spam</li>
                            <li> Impersonating others or falsifying relationships</li>
                            <li> Posting or linking obscene content or unauthorized advertisements</li>
                            <li> Participating in or promoting gambling</li>
                            <li> Sending or spreading offensive, disturbing, or frightening content</li>
                            <li> Distributing malicious software or illegal information</li>
                            <li> Impersonating Company staff or misusing names</li>
                            <li> Engaging in other actions that harm the service, violate public order, or break the law</li>
                        </ul>
                        <p>The Company may take necessary measures including deletion or relocation of posts without prior notice and may suspend or terminate the service immediately if any of the above actions are detected.</p>
                    </div>
                </li>

                <li>
                    <div className="titleBox">
                        <p><span>Article 12</span></p><p>Damages</p>
                    </div>
                    <div className="txtWrap">
                        <p>- The Company shall be liable for damages if it causes harm to a Member due to willful misconduct or gross negligence.</p>
                        <p>- If a Member violates these Terms and causes damage to the Company, the Member shall be liable for compensation.</p>
                    </div>
                </li>

                <li>
                    <div className="titleBox">
                        <p><span>Article 13</span></p><p>Disclaimer</p>
                    </div>
                    <div className="txtWrap">
                        <p>- The Company does not guarantee that the service may be used for commercial purposes, and any resulting damages are the Member’s responsibility.</p>
                        <p>- The Company shall not be liable for service suspension or interruption due to force majeure or pre-announced downtimes.</p>
                        <p>- The Company shall not be liable for issues arising from the Member’s own fault.</p>
                        <p>- The Company is not responsible for the accuracy or reliability of content posted by Members.</p>
                        <p>- The Company shall not be responsible for disputes between Members or with third parties.</p>
                        <p>- The Company shall not be liable for damages resulting from violations of laws or these Terms by Members.</p>
                    </div>
                </li>

                <li>
                    <div className="titleBox">
                        <p><span>Article 14</span></p><p>Personal Information</p>
                    </div>
                    <div className="txtWrap">
                        <p>If necessary to provide services, the Company may collect and use personal information of users with separate consent as required by its privacy policy. Such information will only be used within the scope of the consent provided.</p>
                    </div>
                </li>

                <li>
                    <div className="titleBox">
                        <p><span>Article 15</span></p><p>Governing Law and Compliance</p>
                    </div>
                    <div className="txtWrap">
                        <p>Matters not specified in these Terms shall be governed by applicable laws including the Personal Information Protection Act, the Telecommunications Business Act, and the Act on Promotion of Information and Communications Network Utilization and Information Protection, as well as internal policies established by the Company.</p>
                    </div>
                </li>

                <li>
                    <div className="titleBox">
                        <p><span>Article 16</span></p><p>Jurisdiction and Governing Law</p>
                    </div>
                    <div className="txtWrap">
                        <p>These Terms shall be governed by the laws of the Republic of Korea. In the event of a legal dispute between the Company and a Member, the court with jurisdiction over the Company’s place of business shall be the competent court.</p>
                    </div>
                </li>
            </ol>
        </div>
        </>
    )
}